import { useCallback, useEffect, useRef, useState } from 'react';
import { getDeliveryLogs, syncDeliveryLogs } from '../services/api';

export const useEmailDeliveryJournal = (params, enabled) => {
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const requestId = useRef(0);
  const query = JSON.stringify(params);
  const load = useCallback(async (ids = null) => {
    if (!enabled) return;
    const current = ++requestId.current;
    setLoading(true); setError(''); setNotice('');
    try {
      const first = await getDeliveryLogs(JSON.parse(query));
      if (current !== requestId.current) return;
      setData(first.data); setLoading(false);
      const selected = ids || first.data.items.filter(item => item.can_refresh).map(item => item.id);
      if (selected.length) {
        setSyncing(true);
        const sync = await syncDeliveryLogs(selected);
        if (current !== requestId.current) return;
        const results = sync.data.results || [];
        if (results.some(item => ['error', 'unavailable'].includes(item.result))) setNotice('Certains statuts n’ont pas pu être actualisés. Les derniers statuts connus sont conservés.');
        else if (results.every(item => item.result === 'cached')) setNotice('Statuts vérifiés récemment ; nouvelle consultation possible après 30 secondes.');
        const latest = await getDeliveryLogs(JSON.parse(query));
        if (current === requestId.current) setData(latest.data);
      }
    } catch (err) {
      if (current === requestId.current) setError(err.response?.data?.detail || 'Le journal email est temporairement indisponible.');
    } finally {
      if (current === requestId.current) { setLoading(false); setSyncing(false); }
    }
  }, [query, enabled]);
  useEffect(() => { load(); return () => { requestId.current += 1; }; }, [load]);
  return { ...data, loading, syncing, error, notice, refresh: load };
};